// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_55-2";
export var blackBorderOnHover = "_55-7";
export var cell = "_55-6";
export var cellContainer = "_55-3";
export var checked = "_55-8";
export var disabled = "_55-5";
export var featuredIconCellContainer = "_55-9";
export var featuredIconTextContainer = "_55-b";
export var featuredIconWrapper = "_55-a";
export var noBorder = "_55-c";
export var orangeSelectedRow = "_dm-3";
export var overflowableText = "_55-0";
export var overflowableTextContainer = "_55-1";
export var row = "_57-0";
export var rowCheckboxCell = "_55-4";
export var selectableTable = "_dm-2";